import React from "react";
import { Button, Column, Conditional, If, makeClassName, Row } from "@hex-insights/core";
import { StudentDetailQuery } from "../../../Utilities";
import { PersonForm } from "../Person";
import * as StudentForm from "./Form";

export type ControlledDetailProps = Omit<
	StudentForm.ControlledDetailProps,
	"student" | "formStateArgs" | "onSuccess"
> & {
	student: StudentDetailQuery["student"];
	studentFormStateArgs: StudentForm.ControlledDetailProps["formStateArgs"];
	studentOnSuccess: StudentForm.ControlledDetailProps["onSuccess"];
	personFormStateArgs: PersonForm.ControlledDetailProps["formStateArgs"];
	personOnSuccess: PersonForm.ControlledDetailProps["onSuccess"];
};

export function ControlledDetail({
	student,
	studentFormStateArgs,
	personFormStateArgs,
	studentOnSuccess,
	personOnSuccess,
	...props
}: ControlledDetailProps) {
	const [view, setView] = React.useState<"person" | "student">("person");

	return (
		<Column justify="spaced-start" verticalSpacing="1.25rem">
			<Row justify="spaced-start">
				<Button
					onClick={() => setView("person")}
					className={makeClassName("button--nav", view === "person" ? "button--nav--active" : "")}
				>
					Personal Details
				</Button>
				<Button
					onClick={() => setView("student")}
					className={makeClassName("button--nav", view === "student" ? "button--nav--active" : "")}
				>
					Student Details
				</Button>
			</Row>

			<Conditional>
				<If condition={view === "person"}>
					<PersonForm.ControlledDetail
						person={student.person}
						formStateArgs={personFormStateArgs}
						onSuccess={personOnSuccess}
						{...props}
					/>
				</If>
				<If condition={view === "student"}>
					<StudentForm.ControlledDetail
						student={student}
						formStateArgs={studentFormStateArgs}
						onSuccess={studentOnSuccess}
						{...props}
					/>
				</If>
			</Conditional>
		</Column>
	);
}
